import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
/**
 * Pure decision helper — extracted for unit-testing without RTL.
 * Sprint 2.2 L5 : keeps AuthGuard behaviour deterministic and verifiable.
 */
export function decideAuthGuard(input) {
    if (input.isLoading)
        return 'loading';
    if (!input.isAuthenticated)
        return 'redirect';
    return 'render';
}
export function AuthGuard({ children, redirectTo = '/onboarding/welcome' }) {
    const { isAuthenticated, isLoading } = useAuth();
    const decision = decideAuthGuard({ isLoading, isAuthenticated });
    if (decision === 'loading') {
        return _jsx("div", { className: "p-8 text-center font-body text-cyan-text-secondary", children: "\u2026" });
    }
    if (decision === 'redirect') {
        return _jsx(Navigate, { to: redirectTo, replace: true });
    }
    return _jsx(_Fragment, { children: children });
}
//# sourceMappingURL=AuthGuard.js.map